<template>
  <ProgramCardModal
    :programArticle="selectedProgramArticle"
    :scrollToSection="scrollToSection"
    :program-voting-opened="votingOpened"
    :user-logged-in="userLoggedIn"
    :timeslot-selections="timeslotSelectionsMutable"
    @update:timeslotSelections="updateTimeSlot"
    @close="clearSelectedArticle"
  />

  <div class="md:hidden flex flex-col justify-center gap-y-8 mt-[20px]">
    <div class="flex flex-col justify-center gap-y-8 relative">
      <div class="absolute w-full h-full z-[-1] opacity-[0.3] bg-brand-orange" style="filter: blur(150px);"></div>
      <p class="text-[24px] text-brand-orange font-semibold">Retino sál</p>
      <program-card-mobile-card v-for="event in firstHallMorning"
                                :happening="event"
                                :should-have-radio="false"
                                :highlight-color="'orange'"
                                @clicked="selectProgramArticle"
      >

      </program-card-mobile-card>
      <LunchCard :height="96" time="12:15–13:45"></LunchCard>
      <program-card-mobile-card v-for="event in firstHallAfterLunch"
                                :happening="event"
                                :should-have-radio="false"
                                :highlight-color="'orange'"
                                @clicked="selectProgramArticle"
      >
      </program-card-mobile-card>
    </div>
    <div class="flex flex-col justify-center gap-y-8 relative">
      <div class="absolute w-full h-full z-[-1] opacity-[0.3] bg-brand-blue" style="filter: blur(150px);"></div>

      <p class="text-[24px] text-brand-blue font-semibold">Leadhub sál</p>
      <program-card-mobile-card v-for="event in secondHallMorning"
                                :happening="event"
                                :should-have-radio="false"
                                :highlight-color="'blue'"
                                @clicked="selectProgramArticle"
      >

      </program-card-mobile-card>
      <LunchCard :color="'blue'" :height="96" time="12:00–13:45"></LunchCard>
      <program-card-mobile-card v-for="event in secondHallAfterLunch"
                                :happening="event"
                                :should-have-radio="false"
                                :highlight-color="'blue'"
                                @clicked="selectProgramArticle"
      >
      </program-card-mobile-card>
    </div>
    <div class="flex flex-col rounded-[15px] shadow-lg">
      <div class="flex rounded-t-[15px] h-[32px] bg-[#666]">
        <p class="text-[18px] font-bold mx-auto my-auto text-white">17:15–18:00</p>
      </div>
      <div
        class="bg-white flex flex-row rounded-b-[15px] h-[58px] gap-4 justify-items-center justify-center items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
          <path
            d="M9.81079 1.54338C9.70774 1.53964 9.60536 1.56145 9.51279 1.60687C9.42021 1.6523 9.34031 1.71991 9.28021 1.80371C9.2201 1.8875 9.18166 1.98486 9.16831 2.08711C9.15496 2.18936 9.16712 2.29332 9.20369 2.38973C9.59437 3.46411 9.6686 4.24932 9.47387 4.98495C9.30901 5.60776 8.9141 6.24132 8.25805 6.9633L7.85685 6.5621C7.4878 6.19305 6.97501 6.0817 6.51082 6.18531C6.04663 6.28891 5.63098 6.60827 5.45369 7.09921L1.28702 18.6308C1.2468 18.7424 1.23917 18.8632 1.26503 18.979C1.29089 19.0948 1.34918 19.2008 1.43308 19.2847C1.51697 19.3686 1.62302 19.4269 1.73881 19.4527C1.85461 19.4786 1.97537 19.471 2.08699 19.4307L13.6194 15.2641V15.2649C14.6016 14.9109 14.8934 13.6002 14.1557 12.8617C14.1557 12.8615 14.1557 12.8612 14.1557 12.8609L13.7504 12.4557C14.474 11.7975 15.1089 11.4017 15.7328 11.2366C16.4685 11.0419 17.2537 11.1161 18.328 11.5068C18.4053 11.5352 18.4874 11.5481 18.5697 11.5448C18.652 11.5414 18.7328 11.5218 18.8075 11.4871C18.8821 11.4524 18.9492 11.4033 19.0049 11.3426C19.0605 11.2819 19.1036 11.2109 19.1317 11.1335C19.1598 11.0561 19.1723 10.9739 19.1685 10.8916C19.1648 10.8094 19.1448 10.7287 19.1097 10.6541C19.0747 10.5796 19.0252 10.5128 18.9643 10.4574C18.9033 10.4021 18.832 10.3593 18.7545 10.3316C18.1458 10.1103 17.5694 9.96563 17.0154 9.91089C16.4614 9.85615 15.9298 9.89107 15.4122 10.0281C14.514 10.2658 13.6991 10.7915 12.8601 11.5654L11.0754 9.78068C11.258 9.70974 11.4448 9.69711 11.7167 9.67489C12.1979 9.63557 12.9452 9.5399 13.5909 8.89445C14.2369 8.24845 14.3319 7.50167 14.3713 7.02027C14.4108 6.53887 14.3944 6.3232 14.7904 5.92733C15.1865 5.53143 15.4027 5.54776 15.8842 5.50822C16.3656 5.46869 17.1126 5.373 17.7584 4.72697C17.8486 4.63911 17.9102 4.52605 17.9351 4.40259C17.9599 4.27913 17.9469 4.15104 17.8977 4.0351C17.8486 3.91916 17.7655 3.82078 17.6595 3.75284C17.5534 3.68491 17.4293 3.65059 17.3035 3.65438C17.1414 3.65932 16.9877 3.72702 16.8746 3.84318C16.4787 4.23925 16.263 4.22277 15.7817 4.26229C15.3003 4.30182 14.5527 4.39778 13.9067 5.04354C13.2606 5.68934 13.1657 6.43632 13.1262 6.91773C13.0867 7.39914 13.1032 7.61458 12.7071 8.01066C12.3116 8.40605 12.0963 8.38963 11.615 8.42896C11.2365 8.45988 10.6934 8.5295 10.1648 8.87004L9.14835 7.8536C9.92007 7.01595 10.4442 6.20243 10.6816 5.30559C10.9556 4.27038 10.8215 3.18059 10.3788 1.9633C10.3375 1.84419 10.2612 1.74035 10.1598 1.66541C10.0584 1.59046 9.93677 1.54793 9.81079 1.54338ZM12.9163 2.38485C12.7818 2.38485 12.6471 2.43595 12.5443 2.53866L12.2367 2.84628C12.0313 3.05169 12.0313 3.38468 12.2367 3.59009L12.5443 3.89771C12.7498 4.10271 13.0827 4.10271 13.2882 3.89771L13.5958 3.59009C13.8012 3.38468 13.8012 3.05169 13.5958 2.84628L13.2882 2.53866C13.1855 2.43595 13.0507 2.38485 12.9163 2.38485ZM6.24959 3.63485C6.11511 3.63485 5.98039 3.68595 5.87768 3.78866L5.57006 4.09628C5.36465 4.30169 5.36465 4.63468 5.57006 4.84009L5.87768 5.14771C6.0831 5.35271 6.41608 5.35271 6.6215 5.14771L6.92911 4.84009C7.13453 4.63468 7.13453 4.30169 6.92911 4.09628L6.6215 3.78866C6.51879 3.68595 6.38407 3.63485 6.24959 3.63485ZM3.74959 5.50985C3.61511 5.50985 3.48039 5.56095 3.37768 5.66366L3.07006 5.97128C2.86465 6.17669 2.86465 6.50968 3.07006 6.71509L3.37768 7.02271C3.5831 7.22771 3.91608 7.22771 4.1215 7.02271L4.42911 6.71509C4.63453 6.50968 4.63453 6.17669 4.42911 5.97128L4.1215 5.66366C4.01879 5.56095 3.88407 5.50985 3.74959 5.50985ZM6.77693 7.37509C6.83961 7.36109 6.90963 7.38408 6.97225 7.4467C6.97252 7.4467 6.97279 7.4467 6.97306 7.4467L13.2719 13.7455C13.3967 13.8712 13.362 14.0281 13.1954 14.0881C13.1951 14.0884 13.1948 14.0887 13.1946 14.089L2.91463 17.8031L6.62882 7.5232C6.65903 7.43955 6.71425 7.38908 6.77693 7.37509ZM16.6663 7.38485C16.5318 7.38485 16.3971 7.43595 16.2943 7.53866L15.9867 7.84628C15.7813 8.05169 15.7813 8.38468 15.9867 8.59009L16.2943 8.89771C16.4998 9.10271 16.8327 9.10271 17.0382 8.89771L17.3458 8.59009C17.5512 8.38468 17.5512 8.05169 17.3458 7.84628L17.0382 7.53866C16.9355 7.43595 16.8007 7.38485 16.6663 7.38485ZM16.6663 12.8015C16.5318 12.8015 16.3971 12.8526 16.2943 12.9553L15.9867 13.2629C15.7813 13.4684 15.7813 13.8013 15.9867 14.0068L16.2943 14.3144C16.4998 14.5194 16.8327 14.5194 17.0382 14.3144L17.3458 14.0068C17.5512 13.8013 17.5512 13.4684 17.3458 13.2629L17.0382 12.9553C16.9355 12.8526 16.8007 12.8015 16.6663 12.8015ZM15.4163 15.7182C15.2818 15.7182 15.1471 15.7693 15.0443 15.872L14.7367 16.1796C14.5313 16.385 14.5313 16.718 14.7367 16.9234L15.0443 17.231C15.2498 17.436 15.5827 17.436 15.7882 17.231L16.0958 16.9234C16.3012 16.718 16.3012 16.385 16.0958 16.1796L15.7882 15.872C15.6855 15.7693 15.5507 15.7182 15.4163 15.7182Z"
            fill="#111827"/>
        </svg>
        <p class="text-[20px] font-normal text-[#111827]">Afterparty</p>
      </div>
    </div>
  </div>

  <div class="hidden md:grid justify-center gap-x-4 w-full grid-cols-2 mt-[72px] relative">
    <div class="absolute w-[25%] h-[90%] bg-[#2699C6] opacity-70 z-[-1] top-0 right-0"
         style="filter: blur(400px); border-radius: 1943px;"></div>
    <div class="absolute w-[25%] h-[90%] bg-[#F4A02D] opacity-70 z-[-1] top-0 left-0"
         style="filter: blur(400px); border-radius: 1943px;"></div>
    <div class="mb-5">
      <h2 class="text-left font-semibold text-brand-orange text-[32px]">Leadhub sál</h2>
    </div>

    <div class="mb-5">
      <h2 class="text-right font-semibold text-[#2699C6] text-[32px]">
        Retino sál
      </h2>
    </div>
    <div>
      <ProgramCardNew
        v-for="(happening, i) in firstHallMorning"
        :key="i"
        :programArticle="happening"
        :textTruncateChars="105"
        @clicked="selectProgramArticle"
        :timeslotSelections="timeslotSelectionsMutable"
        :userLoggedIn="userLoggedIn"
        :program-voting-opened="votingOpened"
        @update:timeslotSelections="updateTimeSlot"
        class="mb-[20px]"
      />
      <LunchCard class="my-[10px] mb-[20px]" :height="96" time="12:15–13:45"></LunchCard>
      <template v-for="(happening, i) in firstHallAfterLunch"
                :key="i">
        <ProgramCardNew
          :programArticle="happening"
          @clicked="selectProgramArticle"
          :textTruncateChars="105"
          :timeslotSelections="timeslotSelectionsMutable"
          :userLoggedIn="userLoggedIn"
          :program-voting-opened="votingOpened"
          @update:timeslotSelections="updateTimeSlot"
          class="mb-[20px]"
        />
      </template>
    </div>

    <div>
      <ProgramCardNew
        v-for="(happening, i) in secondHallMorning"
        :key="i"
        :textTruncateChars="105"
        :programArticle="happening"
        @clicked="selectProgramArticle"
        :timeslotSelections="timeslotSelectionsMutable"
        :userLoggedIn="userLoggedIn"
        :program-voting-opened="votingOpened"
        @update:timeslotSelections="updateTimeSlot"
        :color="'blue'"
        class="mb-[20px]"
      />
      <LunchCard class="my-[10px] mb-[20px]" :color="'blue'" :height="96" time="12:00–13:45"></LunchCard>

      <template v-for="(happening, i) in secondHallAfterLunch"
                :key="i">
        <ProgramCardNew
          class="mb-[20px]"
          :programArticle="happening"
          @clicked="selectProgramArticle"
          :textTruncateChars="105"
          :timeslotSelections="timeslotSelectionsMutable"
          :userLoggedIn="userLoggedIn"
          :program-voting-opened="votingOpened"
          @update:timeslotSelections="updateTimeSlot"
          :color="'blue'"
        />
      </template>
    </div>
    <div class="flex flex-col rounded-[15px] shadow-lg col-span-2">
      <div class="flex rounded-t-[15px] h-[44px] bg-[#666]">
        <p class="text-[24px] font-bold mx-auto my-auto text-white">17:15–18:00</p>
      </div>
      <div
        class="bg-white flex flex-row rounded-b-[15px] h-[128px] gap-4 justify-items-center justify-center items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="49" viewBox="0 0 50 49" fill="none">
          <path
            d="M24.5462 2.79786C24.2981 2.78889 24.0517 2.84124 23.8288 2.95025C23.606 3.05926 23.4136 3.22155 23.2689 3.42264C23.1242 3.62374 23.0317 3.8574 22.9996 4.1028C22.9674 4.3482 22.9967 4.59772 23.0847 4.82911C24.0252 7.40762 24.2039 9.29211 23.7352 11.0576C23.3383 12.5524 22.3876 14.0729 20.8083 15.8057L19.8424 14.8428C18.954 13.9571 17.7196 13.6898 16.6021 13.9385C15.4846 14.1871 14.484 14.9536 14.0572 16.1318L4.02663 43.8076C3.92979 44.0755 3.91142 44.3654 3.97368 44.6433C4.03595 44.9212 4.17626 45.1757 4.37823 45.377C4.5802 45.5784 4.83548 45.7183 5.11424 45.7803C5.39299 45.8424 5.68371 45.8241 5.95242 45.7276L33.7148 35.7276V35.7295C36.0794 34.8799 36.7818 31.7341 35.0058 29.9619C35.0058 29.9613 35.0058 29.9606 35.0058 29.96L34.0302 28.9873C35.7721 27.4077 37.3007 26.4579 38.8026 26.0615C40.5735 25.5942 42.4638 25.7723 45.0501 26.71C45.2361 26.7783 45.4339 26.8093 45.6319 26.8012C45.83 26.7931 46.0245 26.7461 46.2042 26.6629C46.384 26.5796 46.5455 26.4618 46.6795 26.3161C46.8134 26.1704 46.9172 25.9998 46.9848 25.814C47.0524 25.6283 47.0826 25.431 47.0735 25.2336C47.0644 25.0362 47.0163 24.8425 46.9319 24.6637C46.8475 24.4849 46.7285 24.3244 46.5818 24.1916C46.435 24.0588 46.2634 23.9562 46.0767 23.8897C44.6115 23.3585 43.2238 23.0113 41.8901 22.8799C40.5564 22.7485 39.2767 22.8323 38.0307 23.1611C35.8683 23.7318 33.9068 24.9933 31.887 26.8506L27.5907 22.5674C28.0303 22.3971 28.4799 22.3668 29.1344 22.3135C30.2929 22.2191 32.0918 21.9895 33.6462 20.4404C35.2014 18.89 35.43 17.0978 35.525 15.9424C35.62 14.787 35.5806 14.2694 36.5339 13.3193C37.4874 12.3692 38.0079 12.4084 39.167 12.3135C40.326 12.2186 42.1242 11.9889 43.6788 10.4385C43.896 10.2276 44.0442 9.95626 44.1041 9.65996C44.164 9.36366 44.1326 9.05625 44.0143 8.77799C43.8959 8.49973 43.696 8.26361 43.4407 8.10057C43.1854 7.93753 42.8867 7.85516 42.5836 7.86427C42.1936 7.87612 41.8234 8.03859 41.5512 8.31739C40.5981 9.26794 40.0789 9.22839 38.9201 9.32325C37.7613 9.41812 35.9616 9.64842 34.4064 11.1983C32.8511 12.7482 32.6226 14.5409 32.5276 15.6963C32.4325 16.8517 32.4721 17.3688 31.5187 18.3193C30.5664 19.2683 30.0482 19.2289 28.8895 19.3233C27.9785 19.3975 26.671 19.5645 25.3984 20.3818L22.9515 17.9424C24.8093 15.932 26.071 13.9796 26.6425 11.8272C27.3021 9.34267 26.9793 6.72717 25.9137 3.80567C25.8143 3.5198 25.6305 3.27058 25.3864 3.09072C25.1424 2.91086 24.8495 2.80878 24.5462 2.79786ZM32.0221 4.81739C31.6984 4.81739 31.3741 4.94003 31.1268 5.18653L30.3863 5.92482C29.8918 6.41782 29.8918 7.21697 30.3863 7.70997L31.1268 8.44825C31.6213 8.94025 32.4229 8.94025 32.9174 8.44825L33.658 7.70997C34.1525 7.21697 34.1525 6.41782 33.658 5.92482L32.9174 5.18653C32.6702 4.94003 32.3459 4.81739 32.0221 4.81739ZM15.9732 7.81739C15.6495 7.81739 15.3252 7.94003 15.0779 8.18653L14.3374 8.92482C13.8429 9.41782 13.8429 10.217 14.3374 10.71L15.0779 11.4483C15.5724 11.9403 16.374 11.9403 16.8685 11.4483L17.6091 10.71C18.1036 10.217 18.1036 9.41782 17.6091 8.92482L16.8685 8.18653C16.6213 7.94003 16.2969 7.81739 15.9732 7.81739ZM9.95486 12.3174C9.63112 12.3174 9.30681 12.44 9.05955 12.6865L8.31901 13.4248C7.82451 13.9178 7.82451 14.717 8.31901 15.21L9.05955 15.9483C9.55406 16.4403 10.3557 16.4403 10.8502 15.9483L11.5907 15.21C12.0852 14.717 12.0852 13.9178 11.5907 13.4248L10.8502 12.6865C10.6029 12.44 10.2786 12.3174 9.95486 12.3174ZM17.2427 16.794C17.3936 16.7604 17.5621 16.8155 17.7129 16.9658C17.7135 16.9658 17.7142 16.9658 17.7148 16.9658L32.8783 32.083C33.1787 32.3845 33.0953 32.7611 32.6941 32.9053C32.6935 32.9059 32.6928 32.9066 32.6922 32.9072L7.94483 41.8213L16.8861 17.1494C16.9589 16.9487 17.0918 16.8275 17.2427 16.794ZM41.0497 16.8174C40.7259 16.8174 40.4016 16.94 40.1544 17.1865L39.4138 17.9248C38.9193 18.4178 38.9193 19.217 39.4138 19.71L40.1544 20.4483C40.6489 20.9403 41.4505 20.9403 41.945 20.4483L42.6855 19.71C43.18 19.217 43.18 18.4178 42.6855 17.9248L41.945 17.1865C41.6977 16.94 41.3734 16.8174 41.0497 16.8174ZM41.0497 29.8174C40.7259 29.8174 40.4016 29.94 40.1544 30.1865L39.4138 30.9248C38.9193 31.4178 38.9193 32.217 39.4138 32.71L40.1544 33.4483C40.6489 33.9403 41.4505 33.9403 41.945 33.4483L42.6855 32.71C43.18 32.217 43.18 31.4178 42.6855 30.9248L41.945 30.1865C41.6977 29.94 41.3734 29.8174 41.0497 29.8174ZM38.0405 36.8174C37.7168 36.8174 37.3924 36.94 37.1452 37.1865L36.4046 37.9248C35.9101 38.4178 35.9101 39.217 36.4046 39.71L37.1452 40.4483C37.6397 40.9403 38.4413 40.9403 38.9358 40.4483L39.6763 39.71C40.1708 39.217 40.1708 38.4178 39.6763 37.9248L38.9358 37.1865C38.6885 36.94 38.3642 36.8174 38.0405 36.8174Z"
            fill="#111827"/>
        </svg>
        <p class="text-[32px] font-medium text-[#111827]">Afterparty</p>
      </div>
    </div>
  </div>
</template>
<script>
import ProgramCardModal from "./ProgramCardModal.vue";
import ProgramCard from "./ProgramCard.vue";
import ProgramCardMobile from "./ProgramCardMobile.vue";
import {isAfter, isBefore, parse} from "date-fns";
import LunchCard from "./LunchCard.vue";
import ProgramCardMobileCard from "./ProgramCardMobileCard.vue";
import ProgramCardNew from "./ProgramNew/ProgramCardNew.vue";

export default {
  components: {
    ProgramCard,
    ProgramCardMobileCard,
    ProgramCardModal,
    ProgramCardNew,
    ProgramCardMobile,
    LunchCard
  },

  props: {
    programEvents: {
      type: Array,
      default: () => [],
    },

    timeslotSelections: {
      type: Object,
      default: undefined,
    },

    userLoggedIn: {
      type: Boolean,
      default: true,
    },

    votingOpened: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      selectedProgramArticle: null,
      hall1: "heureka",
      hall2: "purple",
      timeslotSelectionsMutable: this.timeslotSelections,
      scrollToSection: false
    };
  },

  computed: {
    canVote() {
      return this.userLoggedIn && this.votingOpened;
    },
    groupedByIsBeforeLunch() {
      return this.programEvents.filter((event) => !this.isAfterLunch(event) && event.type !== "workshop" && event.type !== "mastermind")
    },
    groupedByIsAfterLunch() {
      return this.programEvents.filter((event) => this.isAfterLunch(event) && event.type !== "workshop" && event.type !== "mastermind")
    },

    groupedByTimeSlots() {
      const happenings = this.programEvents.filter(
        (event) => event.type !== "workshop" && event.type !== "mastermind" && event.timeslot !== null
      );

      const grouped = happenings.reduce((groupedHappenings, happening) => {
        if (groupedHappenings[happening.timeslot.index] == null) {
          groupedHappenings[happening.timeslot.index] = [];
        }

        if (
          groupedHappenings[happening.timeslot.index][happening.hall] == null
        ) {
          groupedHappenings[happening.timeslot.index][happening.hall] = [];
        }

        groupedHappenings[happening.timeslot.index][happening.hall].push(
          happening
        );

        return groupedHappenings;
      }, {});

      return grouped;
    },

    firstHall() {
      return this.programEvents
        .filter((e) => e.hall === this.hall1)
        .sort((firstEvent, secondEvent) => {
          const isBef = isBefore(
            parse(firstEvent.start, "HH:mm", new Date()),
            parse(secondEvent.start, "HH:mm", new Date())
          );

          //Safari coertion fix
          return isBef ? -1 : 1;
        });
    },

    secondHall() {
      return this.programEvents
        .filter((e) => e.hall === this.hall2)
        .sort((firstEvent, secondEvent) => {
          const isBef = isBefore(
            parse(firstEvent.start, "HH:mm", new Date()),
            parse(secondEvent.start, "HH:mm", new Date())
          );

          //Safari coertion fix
          return isBef ? -1 : 1;
        });
    },

    firstHallMorning() {
      return this.firstHall.filter(event => !this.isAfterLunch(event))
    },

    secondHallMorning() {
      return this.secondHall.filter(event => !this.isAfterLunch(event))
    },

    firstHallAfterLunch() {
      return this.firstHall.filter(event => this.isAfterLunch(event))
      //return this.getEventsWithPlaceholders()[0];
    },

    secondHallAfterLunch() {
      return this.secondHall.filter(event => this.isAfterLunch(event))
      //return this.getEventsWithPlaceholders()[1];
    },
  },

  methods: {
    getEventsWithPlaceholders() {
      const byTimeslotAfternoon = this.groupedByTimeSlots;

      const halls = [[], []];

      for (const timeslot in Object.keys(byTimeslotAfternoon)) {
        if (Number(timeslot) < 3) continue; // only consider afternoon events
        const group = byTimeslotAfternoon[timeslot];
        const firstHall = group?.heureka ?? [];
        const secondHall = group?.purple ?? [];

        const maxSize = Math.max(firstHall.length, secondHall.length);
        for (const event of firstHall) {
          halls[0].push({"event": event, "placeholder": false});
        }
        for (const event of secondHall) {
          halls[1].push({"event": event, "placeholder": false});
        }
        for (let i = firstHall.length; i < maxSize; i++) {
          halls[0].push({"placeholder": true});
        }
        for (let i = secondHall.length; i < maxSize; i++) {
          halls[1].push({"placeholder": true});
        }
      }

      return halls;
    },
    parseDate(time) {
      return parse(time, "HH:mm", new Date());
    },
    isAfterLunch(event) {
      const date = this.parseDate(event.start);
      const lunch = this.parseDate("13:30");
      return isAfter(date, lunch);
    },
    selectProgramArticleAndAddToURL(article) {
      this.selectedProgramArticle = article;

      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('programId', article.id)

      const newRelativePathQuery = window.location.pathname + '?' + urlParams.toString();
      history.pushState(null, '', newRelativePathQuery);
    },
    selectProgramArticle(article) {
      this.scrollToSection = false;
      this.selectProgramArticleAndAddToURL(article);
    },
    clearSelectedArticle() {
      this.selectedProgramArticle = undefined;
      history.pushState(null, '', window.location.pathname);
    },
    updateTimeSlot(newTimeSlots) {
      this.timeslotSelectionsMutable = {...newTimeSlots};
    },

    selectArticleIfPresentInSearchParams() {
      const urlParams = new URLSearchParams(window.location.search);
      const programId = urlParams.get('programId');

      if (programId !== undefined) {
        this.programEvents.forEach((event) => {
          if (event.id === Number(programId)) {
            this.scrollToSection = true;
            this.selectProgramArticleAndAddToURL(event);
          }
        });
      }
    }
  },

  mounted() {
    this.selectArticleIfPresentInSearchParams();
  }
};
</script>

<style>
</style>
